import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { API_CALLS_EXAMPLES, API_CALLS_HINT } from '../constants/apiUsageCopy';
import { tokens } from '../theme/tokens';

/**
 * The one "what counts as an API call" explainer, as a keyboard-focusable
 * info button: the definition plus the three usage examples, on hover, tap
 * or focus. Used wherever a monthly API allowance is shown.
 */
export const ApiCallsHint: React.FC<{ label?: string; size?: number }> = ({ label = 'What counts as an API call', size = 13 }) => (
  <Tooltip
    enterTouchDelay={0}
    title={
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, py: 0.25 }}>
        <span>{API_CALLS_HINT}</span>
        <Box component="ul" sx={{ m: 0, pl: 2, display: 'flex', flexDirection: 'column', gap: 0.4 }}>
          {API_CALLS_EXAMPLES.map(example => (
            <li key={example}>{example}</li>
          ))}
        </Box>
      </Box>
    }
  >
    <IconButton size="small" aria-label={label} sx={{ p: 0.25, color: tokens.ink.faint }}>
      <InfoOutlined sx={{ fontSize: size }} />
    </IconButton>
  </Tooltip>
);
